<template>
  <div v-show="showDetails">
    <!-- <div id='overlay' @click='$emit("close-details")'></div> -->
    <div id="details" v-bind="$attrs">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item bg-${statusColor}`">
          <h5 class="mb-0 pt-1">
            {{ device_name }}
          </h5>
          <div class="update"><clock-icon title="" /> {{ updated }}</div>
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)"
        >
          Informações
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'charts' ? 'active' : ''}`"
          @click="selectDetails(1)"
        >
          Gráficos
        </div>
      </header>

      <div class="column details-area pl-2 pr-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <center>
            <span class="dir-id"><strong>{{ item.MODEL === 'CIR' ? 'MAC' : 'ID' }}:</strong> {{ item.UID }}</span>
          </center>

          <div :class="`percent-box bg-${statusColor}`">
            <div
              class="percent-progress bg-3v3"
              :style="`width: ${successPercentage ? successPercentage : '0'}%;`"
            />
            <span class="percent-text">Sinal</span>
            <span class="percent-ping">
              <span v-if="item.RF && item.RF.ttl"
                >{{ parseTTL(item.RF.ttl[0]) }}
              </span>
              <span
                v-if="
                  item.RF &&
                  item.RF.retry &&
                  item.RF.retry.length &&
                  item.RF.retry[0]
                "
              >
                {{ item.RF.retry[0].toString() }} reenvio{{
                  item.RF && item.RF.retry && item.RF.retry[0] == 1 ? "" : "s"
                }}
              </span>
            </span>
            <div class="percent-value">
              {{ successPercentage }}<span class="percent-unit">%</span>
            </div>
          </div>

          <div class="row center-xs info-details">
            <div class="col-xs-4">
              <strong>{{ dirStat() }}</strong
              ><br />Status
            </div>
            <div class="col-xs-4">
              <strong>{{ item.BAT == '0' || item.BAT == 0 ? 'Sem informação' : item.BAT + 'V' }}</strong><br />Bateria
            </div>
            <div class="col-xs-4" v-if="item.NEIGHBOR">
              <strong>{{
                item.NEIGHBOR == "000" ? "CIR" : item.NEIGHBOR
              }}</strong
              ><br />Origem
            </div>
          </div>

          <div class="info-title">Detalhes</div>
          <div class="col-xs-12 info-details">
            <div v-if="item.UID || item.ID">
              <strong>Endereço:</strong>
              {{ regexMTD.test(item.MODEL) ? item.UID : item.ID }}
            </div>
            <div v-if="item.NOTE">
              <strong>Endereço:</strong> <strong>Observação:</strong>
              {{ item.NOTE }}
            </div>
            <div v-if="item.UPTIME">
              <strong>Atividade:</strong> {{ calcTime(item.UPTIME) }}
              {{ item.RST }}
            </div>
            <div v-if="item.VER"><strong>Versão:</strong> {{ item.VER }}</div>
            <div v-if="item.GENERIC">
              <div v-for="(g, i) in item.GENERIC" :key="i">
                <strong>{{ g.NAME }}</strong> {{ g.VALUE }}
              </div>
            </div>
            <span v-if="item.NOTE"
              ><strong>Observação:</strong> {{ item.NOTE }}<br
            /></span>
            <div class="info-title mt-1">{{ item.MODEL }}</div>

            <b-button
              v-if="hasCommands"
              class="col-12 mt-3"
              variant="outline-secondary"
              rounded
              pill
              @click="visible = !visible"
              size="sm"
              :aria-expanded="visible ? 'true' : 'false'"
              :class="visible ? null : 'collapsed'"
            >
              {{ visible ? "Ocultar comandos do dispositivo" : "Exibir comandos do dispositivo" }}
            </b-button>
            <b-collapse id="collapse-dir" class="mb-1" v-model="visible" v-if="hasCommands">
              <div class="mb-4 mt-4">
                <div v-if="canSync" class="buttons">
                  <b-button variant="3v3" block @click="syncDevice" size="sm">
                    Sincronizar
                  </b-button>
                </div>
                <div
                  v-for="button in item.BUTTONS"
                  :key="button.NAME"
                  class="buttons"
                >
                  <b-button variant="3v3" block @click="sendCommand(button.COMMAND)" size="sm">
                    {{ button.NAME }}
                  </b-button>
                </div>
              </div>
            </b-collapse>

            <div class="ios" v-for="type in io" :key="type.value">
              <b-btn block @click="choseIoTable(type.value)" size="sm"
                >{{ type.text }} ({{
                  ioValues[type.value].filter((e) => !!e.name).length
                }})</b-btn
              >
              <div class="max-table-height" v-if="showIo == type.value">
                <b-table
                  striped
                  small
                  responsive
                  :items="ioValues[showIo]"
                  :fields="type.fields"
                >
                  <template slot="name" slot-scope="row">
                    {{ row.item.name || "-" }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 content chart" v-else>
          <dirsCharts
            :eqp="device_type"
            :name="device_name"
            :uid="device_uid"
            :columns="['BAT', 'ACK']"
            :currently-values="{
              BAT: item.BAT,
              ACK: percent,
            }"
            :col-names="[
              {
                value: 'BAT',
                text: 'BATERIA',
              },
              {
                value: 'ACK',
                text: 'SINAL',
              },
            ]"
          />
        </div>
      </div>
      <footer v-if="visibleClose" id="footer">
        <b-btn size="sm" block @click="closeDevicesDetails" variant="secondary">
          Fechar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { cmd } from "@/api";
import dirsCharts from "@/pages/monitoringPages/Dirs/components/DirCharts";
export default {
  name: "dir-details",
  inheritAttrs: false,
  components: {
    dirsCharts,
  },
  props: {
    item: Object,
    visibleClose: {
      type: Boolean,
      default: true, //false in station monitoring page
    },
    successPercentage: Number,
    statusColor: String,
    updated: String,
    ending: String,
    showDetails: Boolean,
    myTime: Object,
    isMobile: Boolean,
  },
  data() {
    return {
      active: "info",
      visible: false,
      percent: 0,
      io: [
        {
          text: "Saídas",
          value: "output",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "stat",
              label: "Status",
            },
          ],
        },
        {
          text: "Entradas Analógicas",
          value: "analog",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "raw",
              label: "bruto",
            },
            {
              key: "mv",
              label: "mv",
            },
          ],
        },
        {
          text: "Hidrômetros",
          value: "input",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "vol_raw",
              label: "Volume bruto",
            },
            {
              key: "vol_real",
              label: "Volume real",
            },
            {
              key: "flow_raw",
              label: "Fluxo bruto",
            },
            {
              key: "flow_real",
              label: "Fluxo real",
            },
          ],
        },
        {
          text: "Sensores de Pulso",
          value: "pulse",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "count",
              label: "Pulsos",
            },
            {
              key: "period",
              label: "Período",
            },
          ],
        },
        {
          text: "SDI-12",
          value: "sdi12",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "raw",
              label: "bruto",
            },
          ],
        },

        {
          text: "I2C",
          value: "i2c",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
            {
              key: "raw",
              label: "bruto",
            },
          ],
        },
        {
          text: "Modbus",
          value: "modbus",
          fields: [
            {
              key: "name",
              label: "Equipamento",
            },
          ],
        },
      ],
      ioValues: {
        output: [],
        input: [],
        pulse: [],
        analog: [],
        i2c: [],
        sdi12: [],
        modbus: [],
      },
      showIo: "",
      regexMTD: new RegExp("MTD"),
    };
  },
  watch: {
    myTime() {
      if (Object.keys(this.myTime).length) {
        this.percent = this.calculatePercentage(this.myTime.n1, this.myTime.n2);
        // console.log('OASDASDAS')
      }
    },
    showDetails(newValue, oldValue) {
      if (!oldValue && newValue) this.showIo = "";
      if (!newValue && oldValue) this.active = "info";
    },
    // successPercentage(){
    //     console.log('SUCCESS ',this.successPercentage)
    // },
    item(newValue, oldValue) {
      this.resetIoValues();
      // if (this.regexMTD.test(this.item.MODEL)) {
      //   // console.log(this.item)
      // } else
      if (Object.keys(newValue).length) {
        // this.active = 'info';

        let out = this.item.MODEL_OUT;
        let an = this.item.MODEL_ANALOGIC;
        let dig = this.item.MODEL_DIGITAL;
        let sdi = this.item.MODEL_SDI12;
        let i2cqt = this.item.MODEL_I2C;
        let output = [];
        let input = [];
        let pulse = [];
        let analog = [];
        let sdi12 = [];
        let i2c = [];
        let modbus = [];
        this.item.OUTPUT.name.map((name, index) => {
          // if (output.length < out)
          output.push({
            name,
            stat: this.item.OUTPUT.stat[index],
          });
        });
        this.item.ANALOG.name.map((name, index) => {
          // if (analog.length < an)
          analog.push({
            name,
            raw: this.item.ANALOG.raw[index],
            mv: this.item.ANALOG.mv[index],
          });
        });
        this.item.INPUT.name.map((name, index) => {
          // if (input.length < dig)
          input.push({
            name,
            vol_raw: this.item.INPUT.vol_raw[index],
            vol_real: this.item.INPUT.vol_real[index],
            flow_raw: this.item.INPUT.flow_raw[index],
            flow_real: this.item.INPUT.flow_real[index],
          });
        });
        this.item.PULSE.name.map((name, index) => {
          // if (pulse.length < dig)
          pulse.push({
            name,
            count: this.item.PULSE.count[index],
            period: this.item.PULSE.period[index],
          });
        });

        this.item.SDI12.name.map((name, index) => {
          // if (sdi12.length < sdi)
          sdi12.push({
            name,
            raw: this.item.SDI12.raw[index],
          });
        });
        this.item.I2C.name.map((name, index) => {
          // if (i2c.length < i2cqt)
          i2c.push({
            name,
            raw: this.item.I2C.raw[index],
          });
        });
        this.item.MODBUS.name.map((name, index) => {
          // if (i2c.length < i2cqt)
          modbus.push({
            name,
          });
        });
        this.ioValues = {
          output,
          input,
          pulse,
          analog,
          i2c,
          sdi12,
          modbus,
        };
      }
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsActuators(newValue);
    },
  },
  computed: {
    device_type() {
      return this.regexMTD.test(this.item.MODEL) ? "MTD" : "DIR";
    },
    device_name() {
      if (this.regexMTD.test(this.item.MODEL)) return this.item.NAME;
      const itemId = Object.keys(this.item).length ? this.item.ID : null;
      const prefix = this.item.MODEL;

      return itemId ? `${prefix} ${itemId}` : `${prefix} (ID não disponível)`;
    },
    device_uid() {
      return this.item.UID;
    },
    hasCommands() {
      return (this.item.BUTTONS && this.item.BUTTONS.length > 0) || this.canSync;
    },
    // Mesmo critério do card em Dirs/View.vue (isNotSynced): campo novo do firmware,
    // undefined em firmwares antigos não deve disparar o botão.
    isNotSynced() {
      return this.item.SYNC === false || this.item.SYNC === 0;
    },
    // SYNC <ADDR> só faz sentido pra DIR (endereço de canal da rota) — MTD usa
    // UID, não tem rota pra sincronizar por esse comando.
    canSync() {
      return this.device_type === "DIR" && this.isNotSynced;
    },
  },
  methods: {
    closeDevicesDetails() {
      this.$emit("close-details");
    },
    resetIoValues() {
      this.ioValues = {
        output: [],
        input: [],
        pulse: [],
        analog: [],
        i2c: [],
        sdi12: [],
        modbus: [],
      };
    },
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    choseIoTable(value) {
      if (this.showIo == value) this.showIo = "";
      else this.showIo = value;
    },
    dirStat() {
      if (this.item.RF) {
        switch (this.item.RF.stat) {
          case 0:
            return "Excelente";
          case 7:
            return "Timeout";
          case 8:
            return "Falha 2";
          case 9:
            return "Falha 1";
        }
      }
      return "Indeterminado";
    },
    parseTTL(ttl) {
      ttl = Math.floor(ttl);
      if (ttl >= 1000) {
        ttl = ttl / 1000;
        ttl = ttl.toFixed(2);
        ttl = ttl + " s";
      } else ttl = ttl + " ms";
      return ttl;
    },
    calcTime(s) {
      s = Number(s);
      let h = Math.floor(s / 3600);
      let min = Math.floor((s % 3600) / 60);
      s = Math.floor((s % 3600) % 60);
      let d = 0;
      if (h > 23) {
        d = parseInt(h / 24);
        h = h - d * 24;
      }
      return (
        (d == 0 ? "" : d + "d ") +
        (h == 0 ? "" : h + "h ") +
        (min == 0 ? "" : min + "min ") +
        (s == 0 ? "" : s + "s ")
      );
    },
    // Mesmo comando SYNC <ADDR> disparado por routeSync() em registers/routes —
    // grava o arquivo em /mnt/fcir/cmd via register.notityCommand no backend.
    syncDevice() {
      wait.show();
      cmd
        .dirsyncroute({ ADDR: this.item.ID })
        .then((ret) => {
          wait.hide();
          alert(ret.log, ret.alert);
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
    // O firmware não escreve resposta em /mnt/fcir/rsp/ pra nenhum comando
    // disparado pelos BUTTONS do JSON de status (Atualizar → DIR_INFO,
    // SDI12_CMD, MB_REFRESH, SNS_REFRESH, HYD_REFRESH: nenhum desses
    // handlers chama set_rsp() no firmware) — só o resultado do próprio
    // reqofw (arquivo de comando gravado ou não) é significativo aqui.
    sendCommand(command) {
      let data = { SET: true, CMD: command, ITEM: this.item.ID };
      wait.show();
      cmd.reqofw(data)
        .then((ret) => {
          wait.hide();
          if (!ret.status) alert(ret.log, ret.alert);
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
  },
};
</script>

<style scoped>
[data-station="disableBottom"] {
  padding-bottom: 0px !important;
}
.percent-box {
  background-color: #8a8a8a;
  border-radius: 10px;
}
.percent-progress {
  border-radius: 10px;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.percent-text,
.percent-value {
  z-index: 2;
}
@keyframes bar-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 80px 80px;
  }
}
.monit-tabs {
  transition: all 0.5s ease;
}
.dir-id {
  font-size: 0.85em;
}
.percent-ping {
  right: 8px;
  z-index: 33;
}
.buttons {
  margin-top: 5px;
}
.ios .btn {
  margin: 5px 0;
}
.ios .max-table-height {
  max-height: 300px;
  overflow: auto;
}
</style>
